import { getEnvStyling } from "./tools";

const grafanaUri = "https://grafana.harborlockers.com/explore";

const getPane = (
  expr = "",
  from = "now-6h",
  to = "now",
  namespace = "",
  datasource_uid = "P8E80F9AEF21F6940"
) => {
  namespace = namespace || getEnvStyling().grafana.namespace;

  return {
    zvr: {
      datasource: datasource_uid,
      queries: [
        {
          refId: "A",
          expr: `{namespace="${namespace}"} ${expr}`,
          queryType: "range",
          datasource: {
            type: "loki",
            uid: datasource_uid,
          },
          editorMode: "builder",
        },
      ],
      range: {
        from: `${from}`,
        to: `${to}`,
      },
      panelsState: {
        logs: {
          visualisationType: "logs",
        },
      },
    },
  };
};

export const getGrafanaUri = (expr, from, to, namespace, datasource_uid) =>
  `${grafanaUri}?schemaVersion=1&orgId=1&panes=` +
  JSON.stringify(getPane(expr, from, to, namespace, datasource_uid));

export const getTimeRangeLogUri = (
  secondsBefore = 3,
  secondsAfter = 1,
  timestamp = "now"
) => {
  const expr = "!= `/healthz`";

  const deltaBefore = secondsBefore * 1000;
  const deltaAfter = secondsAfter * 1000;

  const time = new Date(timestamp);
  const from = time.getTime() - deltaBefore;
  const to = time.getTime() + deltaAfter;

  return getGrafanaUri(expr, from, to);
};

export const getRequestLogUri = (request_id, timestamp) => {
  const expr = `|= \`${request_id}\``;

  const time = timestamp ? new Date(timestamp + "Z") : new Date();
  const delta = 30 * 60 * 1000;
  const from = time.getTime() - delta;
  const to = time.getTime() + delta;

  return getGrafanaUri(expr, from, to);
};
